module.exports = __webpack_public_path__ + "static/media/la.3d622932.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/la.svg
// module id = 696
// module chunks = 0